const bankData = [
  '重庆农村商业银行',
  '河北银行股份有限公司',
  '邯郸市商业银行',
  '张家口市商业银行',
  '沧州银行',
  '德阳银行',
  '绵阳市商业银行',
  '汉口银行',
  '富滇银行',
  '昆山农村商业银行',
  '杭州银行',
  '浙商银行',
  '浙江稠州商业银行',
  '浙江泰隆商业银行',
  '温州银行',
  '鄞州银行',
  '内蒙古银行',
  '包商银行股份有限公司',
  '吉林银行',
  '广西农村信用社（合作银行）',
  '柳州银行',
  '企业银行',
  '台州银行',
  '浙江民泰商业银行',
  '绍兴银行',
  '恒丰银行',
  '德州银行',
  '交通银行',
  '潍坊银行',
  '常熟农村商业银行',
  '江苏银行股份有限公司',
  '南京银行',
  '吴江农村商业银行',
  '云南省农村信用社',
  '兰州银行股份有限公司',
  '宁夏银行',
  '青海银行',
  '龙江银行',
  '哈尔滨银行结算中心',
  '郑州银行',
  '开封市商业银行',
  '洛阳银行',
  '商丘市商业银行',
  '贵阳银行',
  '晋商银行网上银行',
  '中国工商银行',
  '中国农业银行',
  '中国银行',
  '中国建设银行',
  '中信银行',
  '中国光大银行',
  '华夏银行',
  '中国民生银行',
  '深圳发展银行',
  '招商银行',
  '兴业银行',
  '北京银行',
  '天津银行',
  '东莞银行',
  '顺德农村商业银行',
  '天津农商银行',
  '渤海银行',
  '北京农村商业银行',
  '深圳农商行',
  '东莞农村商业银行',
  '中国邮政储蓄银行',
  '外换银行（中国）有限公司',
  '新韩银行中国',
  '韩亚银行',
  '上海农村商业银行',
  '广发银行股份有限公司',
  '锦州银行',
  '大连银行',
  '鞍山市商业银行',
  '青岛银行',
  '齐商银行',
  '烟台银行',
  '济宁银行',
  '泰安市商业银行',
  '临商银行',
  '东营市商业银行',
  '威海市商业银行',
  '日照银行',
  '安徽省农村信用社联合社',
  '长沙银行',
  '南昌银行',
  '上饶银行',
  '广西北部湾银行',
  '上海银行',
  '苏州银行',
  '张家港农村商业银行',
  '宁波银行',
  '湖州银行',
  '厦门银行',
  '海南省农村信用社',
  '湖北农信',
  '昆仑银行',
  '晋城市商业银行',
  '乌鲁木齐市商业银行',
  '邢台银行',
  '南阳市商业银行',
  '漯河市商业银行',
  '攀枝花市商业银行',
  '重庆银行股份有限公司',
  '南粤银行',
  '华润银行',
  '贵阳银行股份有限',
  '贵州省农村信用社联合社',
  '贵州银行',
  '桂林国民村镇银行',
  '桂林市商业银行',
  '桂林银行',
  '桂阳沪农商村镇银行',
  '哈尔滨银行',
  '哈密红星国民村镇银行',
  '哈密市商业银行',
  '哈密天山村镇银行',
  '海口联合农村商业银行',
  '海口农村商业银行',
  '海口苏南村镇银行',
  '海南保亭融兴村镇银行',
  '海南澄迈长江村镇银行股份有限公司',
  '海南儋州绿色村镇银行',
  '海南五指山长江村镇银行股份有限公司',
  '海阳珠江村镇银行',
  '含山惠民村镇银行',
  '南充嘉陵中成村镇银行',
  '南充市商业银行',
  '南京六合九银村镇银行',
  '南靖中成村镇银行',
  '南宁江南国民村镇银行',
  '南宁市商业银行',
  '南阳村镇银行',
  '南洋商业银行',
  '南洋商业银行（中国）',
  '南漳中银富登村镇银行',
  '内江兴隆村镇银行',
  '内蒙古自治区农村信用联合社',
  '宁波东海银行',
  '宁波海曙浦发村镇银行',
  '宁波市鄞州国民村镇银行',
  '宁波通商银行',
  '宁波鄞州农村合作银行',
  '宁波镇海中银富登村镇银行',
  '宁城包商村镇银行',
  '宁国民生村镇银行',
  '宁海中银富登村镇银行',
  '宁津胶东村镇银行',
  '宁晋民生村镇银行',
  '宁夏贺兰回商村镇银行',
  '宁乡沪农商行村镇银行',
  '宁阳沪农商村镇银行',
  '盘山安泰村镇银行股份有限公司',
  '彭山珠江村镇银行',
  '彭州民生村镇银行',
  '蓬莱民生村镇银行',
  '平安银行综合',
  '平顶山银行',
  '平顶山银行股份有限公司',
  '平果国民村镇银行',
  '萍乡安源富民村镇银行',
  '萍乡湘东黄海村镇银行',
  '蒲城中银富登村镇银行',
  '浦城中成村镇银行',
  '浦发银行',
  '普洱民生村镇银行',
  '栖霞中银富登村镇银行',
  '齐河胶东村镇银行',
  '齐鲁银行',
  '綦江民生村镇银行',
  '蕲春中银富登村镇银行',
  '企业银行（中国）',
  '启东珠江村镇银行',
  '迁安襄隆村镇银行',
  '乾安惠民村镇银行',
  '乾县中银富登村镇银行',
  '潜江中银富登村镇银行',
  '黔西花都村镇银行',
  '钦州市钦南国民村镇银行',
  '秦皇岛银行股份有限公司',
  '青岛城阳珠江村镇银行',
  '青岛黄岛舜丰村镇银行',
  '青岛即墨京都村镇银行',
  '青岛胶南海汇村镇银行',
  '阿拉沪农商村镇银行',
  '安福中银富登村镇银行',
  '安国中成村镇银行',
  '安徽当涂新华村镇银行',
  '安徽肥西石银村镇银行',
  '安徽和县新华村镇银行',
  '安徽霍邱联合村镇银行',
  '安徽霍山联合村镇银行',
  '安徽利辛湖商村镇银行',
  '安徽蒙城湖商村镇银行',
  '安徽明光民丰村镇银行',
  '安徽谯城湖商村镇银行',
  '安徽省农村信用社',
  '安徽寿县联合村镇银行',
  '安徽涡阳湖商村镇银行',
  '安徽五河永泰村镇银行',
  '安徽宿松民丰村镇银行',
  '安徽宣州湖商村镇银行',
  '安吉交银村镇银行',
  '安平惠民村镇银行',
  '安顺西秀富民村镇银行',
  '安溪民生村镇银行',
  '安阳珠江村镇银行',
  '安义融兴村镇银行',
  '鞍山银行',
  '宝丰豫丰村镇银行',
  '宝生村镇银行',
  '保定银行',
  '保山隆阳沪农商村镇银行',
  '北京大兴华夏村镇银行',
  '北京大兴九银村镇银行',
  '北京房山沪农商村镇银行',
  '北京怀柔融兴村镇银行',
  '北京门头沟珠江村镇银行',
  '北京密云汇丰村镇银行',
  '北京农商行',
  '北京顺义银座村镇银行',
  '北流柳银村镇银行',
  '北屯国民村镇银行',
  '本溪市商业银行',
  '毕节发展村镇银行',
  '滨海惠民村镇银行',
  '博白柳银村镇银行',
  '博乐国民村镇银行',
  '沧县吉银村镇银行',
  '沧州海兴新华村镇银行',
  '沧州市运河青隆村镇银行',
  '沧州盐山新华村镇银行',
  '曹县中银富登村镇银行',
  '昌吉国民村镇银行',
  '常宁珠江村镇银行',
  '常州新北中成村镇银行',
  '成都银行',
  '朝阳银行',
  '成都农村商业银行',
  '池州贵池民生村镇银行',
  '茌平沪农商村镇银行',
  '楚雄兴彝村镇银行',
  '创兴银行有限公司',
  '慈利沪农商村镇银行',
  '枞阳泰业村镇银行',
  '从化柳银村镇银行',
  '达州市商业银行',
  '大安惠民村镇银行',
  '大方富民村镇银行',
  '大理古城中成村镇银行',
  '大连保税区珠江村镇银行',
  '大连甘井子浦发村镇银行',
  '大连金州联丰村镇银行',
  '大连普兰店汇丰村镇银行',
  '大同市商业银行',
  '大同银行',
  '大洼恒丰村镇银行',
  '大武口石银村镇银行',
  '大新银行（中国）',
  '大邑交银兴民村镇银行',
  '大竹渝农商村镇银行',
  '丹东鼎安村镇银行',
  '丹东银行',
  '单县中银富登村镇银行',
  '德庆华润村镇银行',
  '定安合丰村镇银行',
  '定州中成村镇银行',
  '东丰吉银村镇银行',
  '东莞大朗东盈村镇银行',
  '东莞厚街华业村镇银行',
  '东莞长安村镇银行',
  '东明中银富登村镇银行',
  '东平沪农商村镇银行',
  '东兴国民村镇银行',
  '东亚银行',
  '东营河口中成村镇银行',
  '东营莱商村镇银行',
  '东源泰业村镇银行',
  '掇刀包商村镇银行',
  '鄂尔多斯市东胜蒙银村镇银行',
  '鄂尔多斯市康巴什村镇银行',
  '鄂托克旗汇泽村镇银行',
  '范县德商村镇银行',
  '方大村镇银行',
  '防城港防城国民村镇银行',
  '费县梁邹村镇银行',
  '丰城顺银村镇银行',
  '奉贤浦发村镇银行',
  '佛山高明顺银村镇银行',
  '佛山市三水区农村信用合作社',
  '福鼎恒兴村镇银行',
  '福建福安渝农商村镇银行',
  '福建建瓯石狮村镇银行',
  '福建连江恒欣村镇银行',
  '福建平潭渝农商村镇银行',
  '福建沙县渝农商村镇银行',
  '福建永安汇丰村镇银行',
  '福建漳平民泰村镇银行',
  '福泉富民村镇银行',
  '福山珠江村镇银行',
  '抚顺银行',
  '抚顺银行股份有限公司',
  '阜南中银富登村镇银行',
  '阜宁民生村镇银行',
  '阜新银行',
  '富民浦发村镇银行',
  '甘肃省农村信用社联合社',
  '甘肃银行',
  '甘肃榆中浦发村镇银行',
  '高碑店中成村镇银行',
  '个旧沪农商村镇银行',
  '公安中银富登村镇银行',
  '公主岭浦发村镇银行股份有限公司',
  '古交汇泽村镇银行',
  '谷城中银富登村镇银行',
  '广东恩平汇丰村镇银行',
  '广东华兴银行',
  '广东南海农村商业银行',
  '广东南粤银行',
  '广东南粤银行股份有限公司',
  '广东省农村信用社联合社',
  '广汉珠江村镇银行',
  '广西鹿寨渝农商村镇银行',
  '广西浦北国民村镇银行',
  '广西上林国民村镇银行',
  '广西壮族自治区农村信用社联合社',
  '广元贵商村镇银行',
  '广州白云民泰村镇银行',
  '广州花都稠州村镇银行',
  '广州增城长江村镇银行',
  '贵溪九银村镇银行股份有限公司',
  '贵阳观山湖富民村镇银行',
  '贵阳花溪建设村镇银行',
  '贵阳南明富民村镇银行',
  '贵阳乌当富民村镇银行',
  '贵阳小河科技村镇银行',
  '青岛胶州中成村镇银行',
  '青岛莱西元泰村镇银行',
  '青岛崂山交银村镇银行',
  '青岛农信',
  '青岛平度惠民村镇银行',
  '青海省农村信用社联合社',
  '青县青隆村镇银行',
  '青州中银富登村镇银行',
  '清河金农村镇银行',
  '清徐惠民村镇银行',
  '清远清新惠民村镇银行',
  '邛崃国民村镇银行',
  '琼海国民村镇银行',
  '曲阜中银富登村镇银行',
  '曲靖市商业银行',
  '曲阳中成村镇银行',
  '全椒中银富登村镇银行',
  '泉州银行',
  '日照沪农商村镇银行',
  '日照九银村镇银行',
  '融水柳银村镇银行',
  '汝州玉川村镇银行',
  '瑞丽沪农商村镇银行',
  '三水珠江村镇银行',
  '沙河襄通村镇银行',
  '沙洋中银富登村镇银行',
  '厦门国际银行',
  '厦门翔安民生村镇银行',
  '山东博兴新华村镇银行',
  '山东肥城民丰村镇银行',
  '山东莒南村镇银行',
  '山东兰陵村镇银行股份有限公司',
  '山东梁山民丰村镇银行',
  '山东临朐聚丰村镇银行',
  '山东农村信用联合社',
  '山东省农村信用社联合社',
  '山东邹平青隆村镇银行',
  '山西省农村信用社',
  '陕西洛南阳光村镇银行',
  '陕西省农村信用社联合社',
  '上海商业银行',
  '上海松江民生村镇银行',
  '上杭中成村镇银行',
  '上饶中银富登村镇银行',
  '深圳宝安融兴村镇银行',
  '深圳福田银座村镇银行',
  '深圳光明沪农商村镇银行',
  '深圳龙岗鼎业村镇银行',
  '深圳农村商业银行',
  '深圳前海微众银行',
  '沈阳于洪永安村镇银行',
  '盛京银行',
  '石河子国民村镇银行',
  '石河子交银村镇银行',
  '石门沪农商村镇银行',
  '石嘴山银行',
  '寿光张农商村镇银行',
  '寿阳县汇都村镇银行',
  '舒兰吉银村镇银行',
  '双城惠民村镇银行有限责任公司',
  '双峰沪农商村镇银行',
  '双辽吉银村镇银行',
  '双流诚民村镇银行',
  '丝绸之路银行',
  '四川江油华夏村镇银行',
  '四川省农村信用社联合社',
  '松原宁江惠民村镇银行',
  '松滋中银富登村镇银行',
  '嵩明沪农商村镇银行',
  '苏州吴江中银富登村镇银行',
  '睢宁中银富登村镇银行',
  '遂宁安居融兴村镇银行',
  '遂平恒生村镇银行',
  '太仓民生村镇银行',
  '太仓农村商业银行',
  '太和中银富登村镇银行',
  '泰安沪农商村镇银行',
  '唐山市丰南舜丰村镇银行',
  '唐县汇泽村镇银行',
  '腾冲民生村镇银行',
  '天津宝坻浦发村镇银行',
  '天津滨海农村商业银行',
  '天津华明村镇银行',
  '天津津南村镇银行',
  '天津静海新华村镇银行',
  '天津宁河村镇银行',
  '天津农村商业银行',
  '天津武清村镇银行',
  '天台民生村镇银行',
  '天长民生村镇银行',
  '铁岭农商村镇银行',
  '铁岭新星村镇银行',
  '铁岭银行',
  '通城惠民村镇银行',
  '潼南民生村镇银行',
  '望都中成村镇银行',
  '望江新华村镇银行',
  '威宁富民村镇银行',
  '尉氏合益村镇银行',
  '文安县惠民村镇银行股份有限公司',
  '文昌国民村镇银行',
  '乌海银行股份有限公司',
  '乌鲁木齐米东浦发村镇银行',
  '乌审旗包商村镇银行',
  '无棣中成村镇银行',
  '无为徽银村镇银行',
  '无锡农村商业银行',
  '芜湖泰寿村镇银行',
  '吴江农商行',
  '吴忠市滨河村镇银行',
  '五常惠民村镇银行',
  '五华惠民村镇银行',
  '五家渠国民村镇银行',
  '五莲中银富登村镇银行',
  '武冈包商村镇银行',
  '武汉农村商业银行',
  '武陟射阳村镇银行',
  '西安高陵阳光村镇银行',
  '西安银行',
  '西藏银行',
  '西乌珠穆沁包商惠丰村镇银行',
  '息烽包商黔隆村镇银行',
  '夏津胶东村镇银行',
  '香河益民村镇银行',
  '襄城汇浦村镇银行',
  '响水中银富登村镇银行',
  '项城中银富登村镇银行',
  '象山国民村镇银行',
  '象山中银富登村镇银行',
  '新安融兴村镇银行',
  '新都桂城村镇银行',
  '新韩银行',
  '新疆汇和银行',
  '新疆维吾尔自治区农村信用社联合',
  '新疆维吾尔自治区农村信用社联合社',
  '新津珠江村镇银行',
  '新密郑银村镇银行',
  '信阳珠江村镇银行',
  '星展银行',
  '星展银行香港有限公司',
  '兴和汇泽村镇银行',
  '兴化苏南村镇银行',
  '兴县汇泽村镇银行',
  '兴业柳银村镇银行',
  '修水九银村镇银行',
  '盱眙珠江村镇银行',
  '宣汉诚民村镇银行',
  '宣化中成村镇银行',
  '雅安市商业银行',
  '鄢陵郑银村镇银行',
  '延寿融兴村镇银行',
  '偃师融兴村镇银行',
  '扬州广陵中成村镇银行',
  '阳谷沪农商村镇银行',
  '阳泉市商业银行',
  '尧都农村商业银行',
  '伊犁国民村镇银行',
  '仪征包商村镇银行',
  '沂水中银富登村镇银行',
  '沂源博商村镇银行',
  '宜宾市商业银行',
  '宜都民生村镇银行',
  '宜丰中银富登村镇银行',
  '宜兴阳羡村镇银行',
  '银川掌政石银村镇银行',
  '银海国民村镇银行',
  '营口沿海银行',
  '营口银行股份有限公司',
  '颍上中银富登村镇银行',
  '应城融兴村镇银行',
  '永亨银行',
  '永亨银行（中国）有限公司',
  '永隆银行有限公司',
  '永清吉银村镇银行',
  '永兴沪农商村镇银行',
  '友利银行(中国)',
  '友利银行(中国)有限公司',
  '余杭德商村镇银行',
  '榆林榆阳民生村镇银行',
  '榆树融兴村镇银行',
  '禹城胶东村镇银行',
  '玉溪澄江中成村镇银行',
  '玉溪红塔区兴和村镇银行',
  '元氏信融村镇银行',
  '云浮新兴东盈民生村镇银行',
  '云南安宁稠州村镇银行',
  '云南大理渝农商村镇银行',
  '云南鹤庆渝农商村镇银行',
  '云南香格里拉渝农商村镇银行',
  '云南祥云渝农商村镇银行',
  '枣阳中银富登村镇银行',
  '枣庄银行',
  '泽州浦发村镇银行',
  '渣打银行',
  '张家港渝农商村镇银行',
  '漳浦民生村镇银行',
  '樟树顺银村镇银行',
  '长安银行',
  '长春高新惠民村镇银行',
  '长春南关惠民村镇银行',
  '长春双阳吉银村镇银行',
  '长葛轩辕村镇银行',
  '长江商业银行',
  '长宁中成村镇银行',
  '长沙星沙沪农商村镇银行',
  '长垣民生村镇银行',
  '长治银行股份有限',
  '长子县融汇村镇银行',
  '浙江常山联合村镇银行',
  '浙江岱山稠州村镇银行',
  '浙江德清湖商村镇银行',
  '浙江海盐湖商村镇银行',
  '浙江嘉善联合村镇银行',
  '浙江建德湖商村镇银行',
  '浙江景宁银座村镇银行',
  '浙江兰溪越商村镇银行',
  '浙江乐清联合村镇银行',
  '浙江龙泉民泰村镇银行',
  '浙江龙游义商村镇银行',
  '浙江平湖工银村镇银行',
  '浙江平阳浦发村镇银行',
  '浙江庆元泰隆村镇银行',
  '浙江瑞安湖商村镇银行',
  '浙江三门银座村镇银行',
  '浙江省农村信用社联合社',
  '浙江松阳恒通村镇银行',
  '浙江遂昌富民村镇银行',
  '浙江泰顺温银村镇银行',
  '浙江桐乡民泰村镇银行',
  '浙江温岭联合村镇银行',
  '浙江萧山湖商村镇银行',
  '浙江新昌浦发村镇银行',
  '浙江义乌联合村镇银行',
  '浙江永嘉恒升村镇银行',
  '浙江玉环永兴村镇银行',
  '浙江云和联合村镇银行',
  '浙江长兴联合村镇银行',
  '浙江舟山普陀稠州村镇银行',
  '浙江诸暨联合村镇银行',
  '正蓝旗汇泽村镇银行',
  '志丹民生村镇银行',
  '中德住房储蓄银行',
  '中行新加坡分行',
  '中牟郑银村镇银行',
  '中山东凤珠江村镇银行',
  '中山小榄村镇银行',
  '中原银行',
  '忠县稠州村镇银行',
  '钟祥民生村镇银行',
  '重庆巴南浦发村镇银行',
  '重庆北碚稠州村镇银行',
  '重庆璧山工银村镇银行',
  '重庆大足汇丰村镇银行有限责任公司',
  '重庆丰都汇丰村镇银行',
  '重庆奉节中银富登村镇银行',
  '重庆合川中银富登村镇银行',
  '重庆江津石银村镇银行',
  '重庆九龙坡民泰村镇银行',
  '重庆南川石银村镇银行',
  '重庆彭水民泰村镇银行',
  '重庆黔江银座村镇银行',
  '重庆荣昌汇丰村镇银行',
  '重庆三峡银行',
  '重庆沙坪坝融兴村镇银行',
  '重庆石柱中银富登村镇银行',
  '重庆市大渡口融兴村镇银行',
  '重庆市沙坪坝融兴村镇银行',
  '重庆市武隆融兴村镇银行',
  '重庆市酉阳融兴村镇银行',
  '重庆巫山中银富登村镇银行',
  '重庆银行',
  '重庆渝北银座村镇银行',
  '重庆长寿中银富登村镇银行',
  '珠海华润银行',
  '珠海华润银行股份有限公司',
  '珠海农村商业银行',
  '株洲县融兴村镇银行',
  '准格尔旗包商村镇银行',
  '涿州中成村镇银行',
  '资兴浦发村镇银行',
  '资阳民生村镇银行',
  '邹平浦发村镇银行',
  '遵义红花岗富民村镇银行',
  '韩城浦发村镇银行股份有限公司',
  '罕台村镇银行',
  '合浦国民村镇银行',
  '合阳惠民村镇银行',
  '河北省农村信用社联合社',
  '河间融惠村镇银行',
  '河南方城凤裕村镇银行',
  '河南巩义浦发村镇银行',
  '河南沁阳江南村镇银行',
  '河南省农村信用社联合社',
  '贺州八步东盈村镇银行',
  '赫章富民村镇银行',
  '鹤壁银行',
  '鹤山珠江村镇银行',
  '黑龙江省农村信用联合社',
  '衡水银行',
  '衡阳沪农商村镇银行',
  '洪洞县洪都村镇银行',
  '洪湖融兴村镇银行',
  '湖北大冶泰隆村镇银行',
  '湖北红安长江村镇银行股份有限公司',
  '湖北嘉鱼吴江村镇银行',
  '湖北麻城汇丰村镇银行',
  '湖北随州曾都汇丰村镇银行',
  '湖北天门汇丰村镇银行',
  '湖北仙桃北农商村镇银行',
  '湖北咸安武农商村镇银行',
  '湖北银行',
  '湖北英山长江村镇银行股份有限公司',
  '湖南茶陵浦发村镇银行',
  '湖南衡南浦发村镇银行',
  '湖南农村信用社联合社',
  '湖南平江汇丰村镇银行',
  '湖南省农村信用社联合社',
  '湖南沅江浦发村镇银行',
  '湖州市商业银行',
  '花旗银行',
  '花旗银行(中国)有限公司',
  '花旗银行有限公司',
  '花旗中国',
  '华融湘江银行',
  '华商银行',
  '化德包商村镇银行',
  '桦川融兴村镇银行',
  '桦甸惠民村镇银行',
  '黄骅青隆村镇银行',
  '辉县珠江村镇银行',
  '会宁会师村镇银行',
  '惠安中成村镇银行',
  '惠东惠民村镇银行',
  '惠水恒升村镇银行',
  '惠州仲恺东盈村镇银行',
  '吉安稠州村镇银行',
  '吉安吉州珠江村镇银行',
  '吉林丰满惠民村镇银行',
  '吉林农信联合社',
  '吉林省农村信用社联合社',
  '集宁包商村镇银行',
  '集友银行',
  '济南槐荫沪农商村镇银行',
  '济南长清沪农商村镇银行',
  '嘉定民生村镇银行',
  '嘉祥中银富登村镇银行',
  '嘉兴银行',
  '监利中银富登村镇银行',
  '犍为中成村镇银行',
  '建行厦门分行',
  '建湖中成村镇银行',
  '建水沪农商村镇银行',
  '江都吉银村镇银行',
  '江南农村商业银行',
  '江苏大丰江南村镇银行',
  '江苏丹阳保得村镇银行',
  '江苏东海张农商村镇银行',
  '江苏东台稠州村镇银行',
  '江苏丰县民丰村镇银行',
  '江苏灌南民丰村镇银行',
  '江苏灌云民丰村镇银行',
  '江苏海安盐海村镇银行',
  '江苏邗江联合村镇银行',
  '江苏邗江民泰村镇银行',
  '江苏洪泽金阳光村镇银行',
  '江苏惠山民泰村镇银行',
  '江苏金湖民泰村镇银行',
  '江苏溧水民丰村镇银行',
  '江苏南通如皋包商村镇银行',
  '江苏沛县汉源村镇银行',
  '江苏邳州陇海村镇银行股份有限公司',
  '江苏如东融兴村镇银行',
  '江苏沭阳东吴村镇银行',
  '江苏通州华商村镇银行',
  '江苏新沂汉源村镇银行',
  '江苏长江商业银行',
  '江西赣州银座村镇银行',
  '江西上栗富民村镇银行',
  '江西省农村信用社联合社',
  '江西兴国新华村镇银行',
  '江夏民生村镇银行',
  '江阴农村商业银行',
  '介休市华都村镇银行',
  '界首中银富登村镇银行',
  '金华银行股份有限公司',
  '金沙富民村镇银行',
  '晋商银行',
  '晋中市榆次融信村镇银行',
  '晋中银行',
  '京山中银富登村镇银行',
  '荆门东宝惠民村镇银行',
  '井冈山九银村镇银行',
  '景洪民生村镇银行',
  '九台龙嘉村镇银行',
  '巨野中银富登村镇银行',
  '鄄城包商村镇银行',
  '筠连中成村镇银行',
  '开封新东方村镇银行',
  '开县泰业村镇银行',
  '开阳富民村镇银行',
  '开远沪农商村镇银行',
  '科尔沁包商村镇银行',
  '克拉玛依金龙国民村镇银行',
  '库车国民村镇银行',
  '奎屯国民村镇银行',
  '昆明东川中成村镇银行',
  '昆明禄劝中成村镇银行',
  '昆明马金铺中成村镇银行',
  '昆明石林中成村镇银行',
  '昆山鹿城村镇银行',
  '昆山农信社',
  '来安中银富登村镇银行',
  '莱芜中成村镇银行',
  '莱芜珠江村镇银行',
  '莱阳胶东村镇银行',
  '莱州珠江村镇银行',
  '兰州皋兰新华村镇银行',
  '兰州七里河新华村镇银行',
  '兰州永登新华村镇银行',
  '郎溪新华村镇银行',
  '廊坊市安次区惠民村镇银行',
  '廊坊银行',
  '老河口中银富登村镇银行',
  '乐平融兴村镇银行',
  '乐山市商业银行',
  '耒阳融兴村镇银行',
  '澧县沪农商村镇银行',
  '醴陵沪农商村镇银行',
  '溧阳浦发村镇银行',
  '涟源沪农商村镇银行',
  '凉山州商业银行',
  '辽宁辰州汇通村镇银行股份有限公司',
  '辽宁大石桥隆丰村镇银行',
  '辽宁海城金海村镇银行',
  '辽宁千山金泉村镇银行',
  '辽宁省农村信用社联合社',
  '辽宁岫岩金玉村镇银行',
  '辽宁彰武金通村镇银行股份有限公司',
  '聊城沪农商村镇银行',
  '临沧临翔沪农商村镇银行',
  '临澧沪农商村镇银行',
  '临清沪农商村镇银行',
  '临武浦发村镇银行',
  '临邑中银富登村镇银行',
  '临颍中银富登村镇银行',
  '灵宝融丰村镇银行',
  '灵山泰业村镇银行',
  '柳江柳银村镇银行',
  '柳林汇泽村镇银行',
  '龙泉驿稠州村镇银行',
  '庐江惠民村镇银行',
  '泸水中成村镇银行',
  '泸州市商业银行',
  '陆川柳银村镇银行',
  '滦县中成村镇银行',
  '漯河市郾城包商村镇银行',
  '绿洲国民村镇银行',
  '梅河口民生村镇银行',
  '梅县客家村镇银行',
  '蒙自沪农商村镇银行',
  '孟州射阳村镇银行',
  '弥勒沪农商村镇银行',
  '绵竹浦发村镇银行',
  '民权德商村镇银行',
  '莫力达瓦包商村镇银行',
  '牟平胶东村镇银行',
  '纳雍富民村镇银行',
  '南部县中成村镇银行',
  '南昌昌东九银村镇银行',
  '南昌大丰村镇银行',
  '杭州商业银行股份有限公司',
  '黄河农村商业银行',
  '葫芦岛银行',
  '承德银行',
  '阜新银行结算中心',
  '福建海峡银行',
  '福建省农村信用社',
  '广州农村商业银行',
  '广州银行',
  '赣州银行',
  '徽商银行',
  '江苏省农村信用社联合社',
  '莱商银行',
  '鄂尔多斯银行',
  '平安银行',
  '东光青隆村镇银行'
]
export default bankData



//////////////////
// WEBPACK FOOTER
// ./static/bank/bank.js
// module id = null
// module chunks = 